module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kV0TX"))).then(() => module.bundle.root('d0iPb'));